// extracted by mini-css-extract-plugin
export var description = "styles-module--description--82224";
export var linkText = "styles-module--link-text--c6b86";
export var linkWrapper = "styles-module--link-wrapper--d1baa";
export var plannedTime = "styles-module--plannedTime--28d91";
export var podcasts = "styles-module--podcasts--450df";
export var title = "styles-module--title--8126c";
export var wrapper = "styles-module--wrapper--2939f";